<template>
  <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.13446 2L10.1018 9.5L2.13446 17" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>
